import { combineReducers, configureStore } from "@reduxjs/toolkit";

const authReducer = (
  state = {
    role: -1,
    isLoggedIn: -1,
    isAuthenticated: -1,
  },
  action
) => {
  switch (action.type) {
    case "AUTH_LOAD_SUCCESS":
      return {
        ...state,
        isAuthenticated: action?.payload?.isAuthenticated,
        role: action?.payload?.role,
        isLoggedIn: true,
        user: action?.payload?.result,
      };
    case "AUTH_LOAD_FAILURE":
      return {
        ...state,
        isLoggedIn: false,
        isAuthenticated: false,
        role: -1,
      };
    case "LOGIN_SUCCESS":
      return {
        ...state,
        isLoggedIn: true,
        isAuthenticated: true,
        role: action.payload.role,
        user: action?.payload?.user,
      };

    case "AUTH_LOGOUT_SUCCESS":
      return {
        ...state,
        isAuthenticated: false,
        isLoggedIn: false,
        user: undefined,
        role: -1,
      };
    case "AUTH_FORGOTPASS_MAIL_SUCCESS":
    case "AUTH_FORGOTPASS_SUCCESS":
      return { ...state, error: undefined };
    case "AUTH_USER_CREATE_SUCCESS":
      return { ...state };
    case "GET_PROFILE":
      return {
        ...state,
        user: action.payload,
      };
    default:
      return state;
  }
};

const errorReducer = (
  state = { authError: undefined, carError: undefined },
  action
) => {
  switch (action.type) {
    case "SET_ERROR":
      const temp = {};
      const { payload } = action;

      if (payload.status && payload.status.length) {
        payload.status &&
          payload?.status.forEach((ele) => {
            if (ele.param === "_error") {
              ele.nestedErrors?.forEach((ele1) => {
                const key = ele1.param.split(".").pop();
                temp[key] = ele1.msg;
              });
            } else if (ele.param?.includes("updates.")) {
              const key = ele.param.split(".").slice(1).join(".");
              temp[key] = ele.msg;
            } else {
              temp[ele.path] = ele.msg;
            }
          });
      }

      return { ...state, [`${payload.scope}Error`]: temp };

    default:
      return state;
  }
};

const loadingReducer = (state = { authLoading: false }, action) => {
  switch (action.type) {
    case "SET_LOADING":
      return Object.assign({}, state, {
        [`${action.payload.scope}Loading`]: action.payload.status,
      });
    default:
      return state;
  }
};

const msgReducer = (
  state = { success: undefined, error: undefined },
  action
) => {
  switch (action.type) {
    case "SET_TOAST":
      return Object.assign({}, state, {
        [`${action.payload.scope}`]:
          action.payload.status || "Something went wrong!",
      });
    case "CLEAR_TOAST":
      return { ...state, error: undefined, success: undefined };
    default:
      return state;
  }
};

// Dashboard
const dashboardReducer = (
  state = {
    dashboard: undefined,
  },
  action
) => {
  switch (action.type) {
    case "GET_DASHBOARD":
      return {
        ...state,
        dashboard: action.payload,
      };
    case "CLEAR_DATA":
      return {
        ...state,
        dashboard: undefined,
      };
    default:
      return state;
  }
};

// User Reducer
const userReducer = (
  state = {
    usersData: undefined,
    userDetail: undefined,
    userTypeData: undefined,
    feature: undefined,
    divisionList: undefined,
    divisionIdList: undefined,
    featurePermission: undefined,
  },
  action
) => {
  switch (action.type) {
    case "GET_USERS":
      return {
        ...state,
        usersData: action.payload,
      };
    case "GET_USER_DETAIL":
      return {
        ...state,
        userDetail: action.payload,
      };
    case "GET_USER_TYPE":
      return {
        ...state,
        userTypeData: action.payload,
      };
    case "GET_FEATURE":
      return {
        ...state,
        feature: action.payload,
      };
    case "GET_DIVISION":
      return {
        ...state,
        divisionList: action.payload,
      };
    case "GET_DIVISION_ID":
      return {
        ...state,
        divisionIdList: action.payload,
      };
    case "GET_FEATURE_PERMISSION":
      return {
        ...state,
        featurePermission: action.payload,
      };
    case "CLEAR_DATA":
      return {
        ...state,
        usersData: undefined,
        userDetail: undefined,
        userTypeData: undefined,
        feature: undefined,
        divisionList: undefined,
        divisionIdList: undefined,
        featurePermission: undefined,
      };
    default:
      return state;
  }
};

const helpReducer = (
  state = {
    categoryList: undefined,
    faqList: undefined,
    supportList: undefined,
    supportUserList: undefined,
  },
  action
) => {
  switch (action.type) {
    case "GET_CATEGORY_LIST":
      return {
        ...state,
        categoryList: action.payload,
      };
    case "GET_FAQ_LIST":
      return {
        ...state,
        faqList: action.payload,
      };
    case "GET_SUPPORT_LIST":
      return {
        ...state,
        supportList: action.payload,
      };
    case "GET_SUPPORT_USER_LIST":
      return {
        ...state,
        supportUserList: action.payload,
      };
    case "CLEAR_DATA":
      return {
        ...state,
        categoryList: undefined,
        faqList: undefined,
        supportList: undefined,
        supportUserList: undefined,
      };
    default:
      return state;
  }
};

const aiUsageReducer = (
  state = {
    aiUsageList: undefined,
    aiFeatureList: undefined,
    aiUsageTokenList: undefined,
  },
  action
) => {
  switch (action.type) {
    case "GET_AI_USAGE_LIST":
      return {
        ...state,
        aiUsageList: action.payload,
      };
    case "GET_AI_FEATURE_LIST":
      return {
        ...state,
        aiFeatureList: action.payload,
      };
    case "GET_AI_USAGE_TOKEN_LIST":
      return {
        ...state,
        aiUsageTokenList: action.payload,
      };
    case "CLEAR_DATA":
      return {
        ...state,
        aiUsageList: undefined,
        aiFeatureList: undefined,
        aiUsageTokenList: undefined,
      };
    default:
      return state;
  }
};

const notificationReducer = (
  state = {
    notificationList: undefined,
  },
  action
) => {
  switch (action.type) {
    case "GET_NOTIFICATION_TEMPLATE_LIST":
      return {
        ...state,
        notificationList: action.payload,
      };
    case "CLEAR_DATA":
      return {
        ...state,
        notificationList: undefined,
      };
    default:
      return state;
  }
};

const abTestingReducer = (
  state = {
    abTesting: undefined,
  },
  action
) => {
  switch (action.type) {
    case "GET_AB_TESTING_LIST":
      return {
        ...state,
        abTesting: action.payload,
      };
    case "CLEAR_DATA":
      return {
        ...state,
        abTesting: undefined,
      };
    default:
      return state;
  }
};

const managePlanReducer = (
  state = {
    managePlanList: undefined,
    subscriptionFeature: undefined,
    planHistory: undefined,
    planHistoryInfo: undefined,
    subscription: undefined,
    subscriptionInfo: undefined,
  },
  action
) => {
  switch (action.type) {
    case "GET_MANAGE_PLAN":
      return {
        ...state,
        managePlanList: action.payload,
      };
    case "GET_SUBSCRIPTION_FEATURE":
      return {
        ...state,
        subscriptionFeature: action.payload,
      };
    case "GET_TRANSACTION_HISTORY":
      return {
        ...state,
        planHistory: action.payload,
      };
    case "GET_TRANSACTION_INFO_HISTORY":
      return {
        ...state,
        planHistoryInfo: action.payload,
      };
    case "GET_SUBSCRIPTION_HISTORY":
      return {
        ...state,
        subscription: action.payload,
      };
    case "GET_SUBSCRIPTION_INFO_HISTORY":
      return {
        ...state,
        subscriptionInfo: action.payload,
      };
    case "CLEAR_DATA":
      return {
        ...state,
        managePlanList: undefined,
        subscriptionFeature: undefined,
        planHistory: undefined,
        planHistoryInfo: undefined,
        subscription: undefined,
        subscriptionInfo: undefined,
      };
    default:
      return state;
  }
};

const experienceReducer = (
  state = {
    experience: undefined,
  },
  action
) => {
  switch (action.type) {
    case "GET_IMPORT_EXPERIENCE":
      return {
        ...state,
        experience: action.payload,
      };
    case "CLEAR_DATA":
      return {
        ...state,
        experience: undefined,
      };
    default:
      return state;
  }
};

const emailTemplateReducer = (
  state = {
    emailTemplate: undefined,
  },
  action
) => {
  switch (action.type) {
    case "GET_EMAIL_TEMPLATE":
      return {
        ...state,
        emailTemplate: action.payload,
      };
    case "CLEAR_DATA":
      return {
        ...state,
        emailTemplate: undefined,
      };
    default:
      return state;
  }
};

const documentTemplateReducer = (
  state = {
    documentTemplate: undefined,
  },
  action
) => {
  switch (action.type) {
    case "GET_DOCUMENT_TEMPLATE":
      return {
        ...state,
        documentTemplate: action.payload,
      };
    case "CLEAR_DATA":
      return {
        ...state,
        documentTemplate: undefined,
      };
    default:
      return state;
  }
};

const betaProgramContentReducer = (
  state = {
    FirstYearCharge: 0,
    SecondYearDiscount: 0,
    ThirdYearDiscount: 0,
    BetaScreenContent: "",
    TOEContent: "",
  },
  action
) => {
  switch (action.type) {
    case "UPDATE_BETA_PROGRAM_CONTENT":
      return {
        ...state,
        FirstYearCharge: action.payload.FirstYearCharge,
        SecondYearDiscount: action.payload.SecondYearDiscount,
        ThirdYearDiscount: action.payload.ThirdYearDiscount,
        BetaScreenContent: action.payload.BetaScreenContent,
        TOEContent: action.payload.TOEContent,
      };
    case "CLEAR_DATA":
      return {
        ...state,
        FirstYearCharge: 0,
        SecondYearDiscount: 0,
        ThirdYearDiscount: 0,
        BetaScreenContent: "",
        TOEContent: "",
      };
    default:
      return state;
  }
};

const NewsLetterReducer = (
  state = {
    newsletter: [],
  },
  action
) => {
  switch (action.type) {
    case "GET_NEWSLETTER":
      return {
        ...state,
        newsletter: action.payload,
      };
    case "CLEAR_DATA":
      return {
        ...state,
        newsletter: undefined,
      };
    default:
      return state;
  }
};

const organizationReducer = (
  state = {
    organization: {},
    organizationDetail: {},
  },
  action
) => {
  switch (action.type) {
    case "GET_ORGANIZATION":
      return {
        ...state,
        organization: action.payload,
      };
    case "GET_ORGANIZATION_ID":
      return {
        ...state,
        organizationDetail: action.payload,
      };
    case "CLEAR_DATA":
      return {
        ...state,
        organization: {},
        organizationDetail: {},
      };
    default:
      return state;
  }
};

/**
 * Cosmos Reducer
 * @description This reducer is used to manage the state of the cosmos widgets and pages.
 * It handles actions related to fetching widget keys, updating widget list, updating page list, and clearing data.
 * @param {Object} state - The current state of the cosmos reducer.
 * @param {Object} action - The action object dispatched to the reducer.
 * @param {string} action.type - The type of action being dispatched.
 * @param {any} action.payload - The payload of the action being dispatched.
 * @returns {Object} The new state of the cosmos reducer.
 */
const cosmosReducer = (
  state = {
    widgetKeys: undefined,
    widgetList: undefined,
    pageList: undefined,
    pageData: undefined,
  },
  action
) => {
  switch (action.type) {
    case "FETCH_WIDGET_KEYS":
      return {
        ...state,
        widgetKeys: action.payload,
      };
    case "UPDATE_WIDGET_LIST":
      return {
        ...state,
        widgetList: action.payload,
      };
    case "UPDATE_PAGE_LIST":
      return {
        ...state,
        pageList: action.payload,
      };
    case "UPDATE_PAGE_DATA":
      return {
        ...state, // Copy the existing state
        pageData: {
          ...state.pageData, // Copy the existing pageData
          [action.payload.pageId]: action.payload.data, // Update the specific pageId
        },
      };
    case "CLEAR_DATA":
      return {
        ...state,
        widgetKeys: undefined,
        widgetList: undefined,
        pageList: undefined,
        pageData: undefined,
      };
    default:
      return state;
  }
};

const d = `d-flex`;
const da = `${d} align-items-center`;
const dab = `${da} justify-content-between`;
const tableCard = `card card-shadow rounded-4 border-0 overflow-hidden`;
const tableCardBody = `card-body p-0 shadow-sm`;
const tableClass = `antTable mt-1 antTableCommandDesk`;
const classReducer = (
  state = {
    d: d,
    da: da,
    dab: dab,
    tCard: tableCard,
    tCardBody: tableCardBody,
    tClass: tableClass,
  },
  action
) => {
  switch (action.type) {
    case "CLASS":
      return {
        ...state,
      };
    default:
      return state;
  }
};

const themeDefaultOption = {
  fontFamily: "",
  fontSize: 24,
  color: "",
  style: [], // Bold, Italic, Underline
  align: "", // Left, Center, Right, Justify
};

/**
 * Returns a theme configuration by merging props with default options.
 * @param {Object} props - Optional overrides for the theme.
 * @returns {Object} - Complete theme configuration.
 */
function getThemeOptions(props = {}) {
  return {
    ...themeDefaultOption,
    ...props,
  };
}

const cosmosThemeReducer = (
  state = {
    data: [
      {
        _id: 1,
        name: "Exclusive",
        heading: {
          h1: getThemeOptions({ fontSize: 50, color: "#3961E5" }),
          h2: getThemeOptions({ fontSize: 35, color: "#3961E5" }),
          h3: getThemeOptions({ fontSize: 28, color: "#3961E5" }),
          h4: getThemeOptions({ fontSize: 18, color: "#3961E5" }),
          h5: getThemeOptions({ color: "#3961E5" }),
          h6: getThemeOptions({ color: "#3961E5" }),
        },
        paragraph: getThemeOptions({ fontSize: 18, color: "#000000" }),
        link: getThemeOptions({ fontSize: 16, color: "#FE616F" }),
        list: getThemeOptions({ fontSize: 16, color: "#000000" }),
        caption: getThemeOptions({ fontSize: 18, color: "#1D274A" }),
        icon: { fill: "#1D274A", stroke: "#3961E5" },
      },
      {
        _id: 2,
        name: "Modern",
        heading: {
          h1: getThemeOptions({ fontSize: 48, color: "#2C3E50" }),
          h2: getThemeOptions({ fontSize: 34, color: "#2C3E50" }),
          h3: getThemeOptions({ fontSize: 26, color: "#2C3E50" }),
          h4: getThemeOptions({ fontSize: 20, color: "#2C3E50" }),
          h5: getThemeOptions({ color: "#2C3E50" }),
          h6: getThemeOptions({ color: "#2C3E50" }),
        },
        paragraph: getThemeOptions({ fontSize: 16, color: "#333333" }),
        link: getThemeOptions({ fontSize: 16, color: "#3498DB" }),
        list: getThemeOptions({ fontSize: 16, color: "#333333" }),
        caption: getThemeOptions({ fontSize: 14, color: "#7F8C8D" }),
        icon: { fill: "#7F8C8D", stroke: "#2C3E50" },
      },
      {
        _id: 3,
        name: "Minimal",
        heading: {
          h1: getThemeOptions({ fontSize: 44, color: "#000000" }),
          h2: getThemeOptions({ fontSize: 32, color: "#000000" }),
          h3: getThemeOptions({ fontSize: 24, color: "#000000" }),
          h4: getThemeOptions({ fontSize: 18, color: "#000000" }),
          h5: getThemeOptions({ color: "#000000" }),
          h6: getThemeOptions({ color: "#000000" }),
        },
        paragraph: getThemeOptions({ fontSize: 16, color: "#222222" }),
        link: getThemeOptions({ fontSize: 16, color: "#E74C3C" }),
        list: getThemeOptions({ fontSize: 16, color: "#222222" }),
        caption: getThemeOptions({ fontSize: 12, color: "#555555" }),
        icon: { fill: "#555555", stroke: "#000000" },
      },
    ],
  },
  action
) => {
  switch (action.type) {
    case "CLASS":
      return {
        ...state,
      };
    default:
      return state;
  }
};

const store = configureStore({
  reducer: combineReducers({
    auth: authReducer,
    error: errorReducer,
    loading: loadingReducer,
    msg: msgReducer,
    users: userReducer,
    dashboard: dashboardReducer,
    help: helpReducer,
    aiUsage: aiUsageReducer,
    notification: notificationReducer,
    abTesting: abTestingReducer,
    managePlan: managePlanReducer,
    experience: experienceReducer,
    class: classReducer,
    emailTemplate: emailTemplateReducer,
    documentTemplate: documentTemplateReducer,
    betaProgramContent: betaProgramContentReducer,
    cosmos: cosmosReducer,
    newsletter: NewsLetterReducer,
    organization: organizationReducer,
    cosmosTheme: cosmosThemeReducer,
  }),
});

export default store;
